// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WappParent } from 'weblite-web-wapprunner'
import { addModal } from 'weblite-web-modal-viewer'
import { WappDrawerModal } from './wapp-drawer-modal'

const COMPONENT_ID = 'wappDrawer'

export const showWappDrawer = async ({
  title,
  isFullScreen,
  wappId,
  wisId,
  input,
  parent,
  isForced,
}: {
  title: string
  wappId: string
  wisId: string
  input: any
  parent?: WappParent
  isFullScreen?: boolean
  isForced?: boolean
}) => {
  if (!wappId) return

  await addModal({
    id: COMPONENT_ID,
    props: {
      title,
      hasHeader: !isFullScreen,
      wapp: { wappId, wisId, input },
      parent,
    },
    preventBackClick: isForced,
  })
}

export default {
  [COMPONENT_ID]: {
    Component: WappDrawerModal,
  },
}
